module.exports = __webpack_public_path__ + "static/media/UNIVERSITY-OF-WEST-LONDON.3219b1e0.png";